import ChattaCommunityScreen from '~components/new-chat/school/tag/[slug]'

export default ChattaCommunityScreen
